const readySharedModals = () => {
  const modals = document.querySelectorAll('[data-shared-modal]')

  modals.forEach((modal) => {
    modal.addEventListener('click', () => {
      // Guard against a null target: the referenced modal may not be present on
      // the current page (surfaced during the Vue 3 QA on the dashboard), which
      // otherwise throws "Cannot read properties of null (reading 'style')".
      const target = document.querySelector(modal.dataset.sharedModal)
      if (target) target.style.display = 'flex'
    })
  })
}

export default readySharedModals
